export const SITE = {
  name: "Brian Jones",
  prodUrl: "https://thebrianjones.dev",
  stagingUrl: "https://staging.thebrianjones.dev",
  description:
    "Portfolio of Brian Jones — software engineering leader delivering AI systems, cloud architecture, observability dashboards, and game prototypes.",
  twitter: "@brianjones", // Update with actual handle when available
  github: "https://github.com/twobitshortofabyte",
  linkedin: "https://www.linkedin.com/in/brianjones", // Update with actual URL when available
};

export const ROUTES: Record<
  string,
  {
    title: string;
    description?: string;
    canonical?: string;
    keywords?: string[];
  }
> = {
  "/": {
    title: "Brian Jones – Software Engineering Leader",
    description:
      "Engineering exec who brings order to complexity: AI-native automation, cloud infrastructure, metrics, and teams.",
    canonical: `${SITE.prodUrl}/`,
    keywords: [
      "software engineering",
      "AI automation",
      "cloud infrastructure",
      "engineering leadership",
      "observability",
      "metrics",
    ],
  },
  "/projects": {
    title: "Projects – Brian Jones",
    description:
      "Selected builds: AI automation, QBR metrics dashboards, observability, portfolio platform, and game concepts.",
    canonical: `${SITE.prodUrl}/projects`,
    keywords: [
      "portfolio",
      "projects",
      "AI automation",
      "dashboards",
      "observability",
      "software development",
    ],
  },
  "/resume": {
    title: "Resume – Brian Jones",
    description:
      "25+ years leading engineering orgs. Strategy, delivery, observability, and AI adoption.",
    canonical: `${SITE.prodUrl}/resume`,
    keywords: [
      "resume",
      "engineering leadership",
      "software engineering",
      "career",
      "experience",
    ],
  },
  "/contact": {
    title: "Contact – Brian Jones",
    description:
      "Get in touch for leadership roles, advisory, or collaboration on data/AI/infra projects.",
    canonical: `${SITE.prodUrl}/contact`,
    keywords: [
      "contact",
      "hire",
      "collaboration",
      "engineering leadership",
      "consulting",
    ],
  },
  "/tabletop": {
    title: "Tabletop Gaming – Brian Jones",
    description:
      "Board game collection, reviews, and gaming insights from a software engineer's perspective.",
    canonical: `${SITE.prodUrl}/tabletop`,
    keywords: [
      "tabletop gaming",
      "board games",
      "gaming",
      "hobbies",
      "reviews",
    ],
  },
  "/astrophotography": {
    title: "Astrophotography – Brian Jones",
    description:
      "Capturing the cosmos through long-exposure photography and precision tracking systems.",
    canonical: `${SITE.prodUrl}/astrophotography`,
    keywords: [
      "astrophotography",
      "astronomy",
      "photography",
      "space",
      "telescope",
    ],
  },
  "/dev-stats": {
    title: "Development Statistics – Brian Jones",
    description:
      "GitHub activity, coding patterns, and development metrics visualization.",
    canonical: `${SITE.prodUrl}/dev-stats`,
    keywords: [
      "development stats",
      "GitHub",
      "coding",
      "metrics",
      "visualization",
    ],
  },
  // Optional lab page for future experiments
  "/lab": {
    title: "Lab – Brian Jones",
    description:
      "Sandbox experiments and devlogs: agents, metrics, small tools, and controlled chaos.",
    canonical: `${SITE.prodUrl}/lab`,
    keywords: ["experiments", "devlog", "tools", "prototypes", "innovation"],
  },
};

// Helper function to get current environment URL
export const getCurrentUrl = (): string => {
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname;
    if (hostname.includes("staging")) {
      return SITE.stagingUrl;
    }
  }
  return SITE.prodUrl;
};

// Helper function to get route config with environment-aware canonical
export const getRouteConfig = (path: string) => {
  const config = ROUTES[path] || ROUTES["/"];
  const currentUrl = getCurrentUrl();

  // For staging, keep canonical pointing to production
  return {
    ...config,
    canonical:
      config.canonical?.replace(SITE.prodUrl, currentUrl) ||
      `${currentUrl}${path}`,
  };
};

